import Fancybox from "../../Components/AsyncGallery";
import { Helmet } from "@dr.pogodin/react-helmet";

export default function WorkCulure() {
  const allImages = [
    "chi-2-417x277.webp",
    "chi-1-417x277.webp",
    "chi-4-417x277.webp",
    "chi-6-417x277.webp",
    "chi-8-417x277.webp",
    "christmas-2021.webp",
    "diwali-6-417x277.webp",
    "diwali-7-417x277.webp",
    "diwali-4-417x277.webp",
    "diwali-5-417x277.webp",
    "chi-7-417x277.webp",
    "diwali-2021.webp",
    "di-1-417x277.webp",
    "di-2-417x277.webp",
    "di-4-417x277.webp",
    "di-5-417x277.webp",
    "di-6-417x277.webp",
    "annual-2022.webp",
    "ke-6-417x277.webp",
    "ke-3-417x277.webp",
    "ke-1-417x277.webp",
    "ke-8-417x277.webp",
    "ke-7-417x277.webp",
    "birthday-2022.webp",
    "act-8-417x277.webp",
    "act-2-417x277.webp",
    "act-3-417x277.webp",
    "act-4-417x277.webp",
    "act-6-417x277.webp",
    "activity-2022.webp",
    "na-9-417x277.webp",
    "diw-8-417x277.webp",
    "na-3-417x277.webp",
    "na-7-417x277.webp",
    "na-2-417x277.webp",
    "navratri-2022.webp",
    "diw-2-417x277.webp",
    "diw-4-417x277.webp",
    "diw-5-417x277.webp",
    "diw-6-417x277.webp",
    "diw-7-417x277.webp",
    "diwali-2022.webp",
    "ch-3-417x277.webp",
    "ch-4-417x277.webp",
    "ch-6-417x277.webp",
    "ch-8-417x277.webp",
    "ch-7-417x277.webp",
    "christmas-2022.webp",
    "sa-8-417x277.webp",
    "sa-5-417x277.webp",
    "sa-2-417x277.webp",
    "sa-4-417x277.webp",
    "sa-7-417x277.webp",
    "sankranti-2023.webp",
    "2-5-417x277.webp",
    "4-3-417x277.webp",
    "5-2-417x277.webp",
    "6-2-417x277.webp",
    "7-1-417x277.webp",
    "26-jan-2023.webp",
    "collage-photos-09-scaled-1-417x277.webp",
    "collage-photos-03-scaled-1-417x277.webp",
    "collage-photos-08-scaled-1-417x277.webp",
    "collage-photos-05-scaled-1-417x277.webp",
    "collage-photos-04-scaled-1-417x277.webp",
    "office.webp",
    "birthday-1.webp",
    "birthday-2.webp",
    "birthday-3.webp",
    "birthday-4.webp",
    "birthday-5.webp",
    "birthday-2023.webp",
    "6-417x277.png",
    "4-417x277.png",
    "3-417x277.png",
    "2-417x277.png",
    "1-417x277.png",
    "diwali-2023.webp",
    "party-post-1.webp",
    "party-post-2.webp",
    "party-post-3.webp",
    "party-post-4.webp",
    "party-post-5.webp",
    "annual-2024.webp",
    "diwali-post-1.webp",
    "diwali-post-2.webp",
    "diwali-post-3.webp",
    "diwali-post-5.webp",
    "diwali-post-6.webp",
    "diwali-2024.webp"

  ];
  const reversedImages = [...allImages].reverse();
  return (
    <>

      <Helmet>
        <title>Positive Work Culture | Innovation-driven Environment</title>
        <meta name="description" content="Infinitive Host offers a healthy work-life balance for our employees. Our work culture allows flexibility and stability for employees." />
        <meta name="keywords" content="work culture, company values, workplace environment, team collaboration, employee well-being, professional growth, inclusive workplace, innovation culture, positive work atmosphere, company ethos" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/work-culture`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/work-culture`} />
        <meta property="og:title" content="Positive Work Culture | Innovation-driven Environment" />
        <meta property="og:description" content="Infinitive Host offers a healthy work-life balance for our employees. Our work culture allows flexibility and stability for employees."/>
      </Helmet>
      <div className="banner-bg pt-pb-100-banner bg-dark">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-8 col-xl-8">
              <div className="text-center">
                  <span className="fs-18 fw-bold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Work Culture</span>
                  <h1 className="text-white mb-3 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Culture That Really Cheers You Up
                    </h1>
                  <p className="text-white mb-8 max-text-60 mx-auto text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    Festival celebrations, awards, and team highs-we create a work environment where all effort gets noticed, and success truly feels collective.
                  </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Fancybox>
        <section className="pt-100 pb-100">
          <div className="container">
            <div className="gallery">
              {reversedImages.map((img, index) => (
                <a className="img-card" href={`/images/workculture/${img}`} data-fancybox="gallery" data-caption="1" key={index}>
                  <figure className="img-frame">
                    <img src={`/images/workculture/${img}`} alt={`gallery-${index}`} title="" />
                  </figure>
                </a>
              ))}

            </div>
          </div>
        </section>
      </Fancybox>
    </>
  );
}
